import Flag, { SIZES } from './Flag.vue'

export default Flag
export { SIZES }
